import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  public activeAudience: 'individual' | 'team' = 'individual';

  setAudience(audience: 'individual' | 'team'): void {
    this.activeAudience = audience;
  }
}
